import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableOrgClientDetail = Loadable({
  loader: function loader() {
    return import('../OrgClientDetail.jsx');
  },
  loading: ComponentLoading
});
export default LoadableOrgClientDetail;